angular.module("contactModule").component("contactReloadNotification", {
	templateUrl: "contactReloadNotification/contactReloadNotification.html",
	bindings: {
		delay: "<",
		status: "<",
		message: "<",
		altToReload: "&"
	},
	controller: ["$timeout", "$window", function($timeout, $window) {
		var ctrl = this;

		this.reloadIn = this.delay;

		this.$onInit = () => {
			this.decCounter();
		};

		this.decCounter = () => {
			this.reloadIn--;
			if (this.reloadIn > 0) {
				$timeout(() => {
					this.decCounter();
				}, 1000);
			} else {
				this.reloadPage();
			}
		};

		this.reloadPage = () => {
			var res = undefined;
			if (this.altToReload) {
				res = this.altToReload()
			}

			if (typeof res == "undefined") {
				$window.location.reload();
			}
		};
	}]
});